/** Clase para las coberturas opcionales */

export default class Coverage {
  /** (String): Código de cobertura. */
  coverageCode!: string

  /** (String): Capital asegurado en euros. */
  sumInsured!: string

  constructor(data: any) {
    this.coverageCode = data.coverageCode
    this.sumInsured = data.sumInsured
  }
}
